window.addEventListener('load', function () {
    /**
     * アコーディオンOPEN/CLOSE
     */
    $(function () {
        $(".card-footer").on("click", function () {
            if ($(".custom-control-input").prop('checked') === false) {
                $('.card-body').slideDown(200);
                $(".custom-control-input").prop('checked', true);
            }else{
                $('.card-body').slideUp(200);
                $(".custom-control-input").prop('checked', false);
            }
        });
    });
});
